import { AdminContextProvider } from './AdminContext';
import { WorkforceContextProvider } from './WorkforceContext';
import { PropTypes } from 'prop-types';

export const UserContext = ({ isAdmin, children, impersonatedId }) => {
    if (isAdmin) {
        return (
            <AdminContextProvider impersonatedId={impersonatedId}>
                {children}
            </AdminContextProvider>
        );
    }
    return (
        <WorkforceContextProvider impersonatedId={impersonatedId}>
            {children}
        </WorkforceContextProvider>
    );
};

UserContext.propTypes = {
    isAdmin: PropTypes.bool.isRequired,
};
